/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, March 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import backImg from '../../../../assets/images/Fireboard/back2_red.png';
import classes from './Header.module.css';

const Header = ({ menuType, goBack }) => {
  return (
    <div className={classes.container}>
      <div className={classes.backButton} onClick={goBack}>
        <img src={backImg} className={classes.backImage} alt='Go Back' />
        <span className={classes.headerText}>{menuType === 'modifiers' ? 'Modifiers' : 'Items'}</span>
      </div>
    </div>
  );
};

export default Header;

Header.propTypes = {
  menuType: PropTypes.string,
  goBack: PropTypes.func,
};

Header.defaultProps = {
  menuType: '',
  goBack: () => { },
};
